import React from 'react';

import type { Transaction } from 'types/api/transaction';

import type { StatusTagType } from './StatusTag';
import StatusTag from './StatusTag';

export interface Props {
  status: Transaction['status'];
  errorText?: string | null;
  isLoading?: boolean;
  variant?: 'default' | 'explorer';
}

const TxStatus = ({ status, errorText, isLoading, variant = 'default' }: Props) => {
  if (status === undefined) {
    return null;
  }

  let text;
  let type: StatusTagType;

  switch (status) {
    case 'ok':
      text = 'Success';
      type = 'ok';
      break;
    case 'error':
      text = 'Failed';
      type = 'error';
      break;
    case null:
      text = 'Pending';
      type = 'pending';
      break;
  }

  return (
    <StatusTag
      type={ type }
      text={ text }
      errorText={ errorText }
      isLoading={ isLoading }
      bgColor="#14DCAC1A"
      color="#14DCAC"
      fontSize="12px"
      fontWeight={ variant === 'explorer' ? 400 : undefined }
      lineHeight="16px"
      fontFamily="'Space Grotesk', var(--chakra-fonts-body)"
      borderRadius="4px"
      px="8px"
      py="2px"
      minH="24px"
    />
  );
};

export default TxStatus;
